import moment from 'moment'
import * as types from '../mutation-types'
import { CURRENCY_SYMBOL, ADVANCE_SETTING_SERVICES, ORDER_STATUS } from '../../mixins/constants'

const INITIAL_DATA_ORDERS_TRUCK = {
  isLoading: false,
  orders: []
}
const state = {
  ...INITIAL_DATA_ORDERS_TRUCK
}

// getters
const getters = {
  getStatusLoadingOrdersTruck: (state) => state.isLoading,
  getOrdersTruck: (state) => state.orders
}

// actions
const actions = {
  loadingOrdersTruck({ commit }, value) {
    commit(types.UPDATE_LOADING_ORDERS_TRUCK_STATUS, value)
  },
  setOrdersTruck({ commit }, allServicesOrders) {
    let ordersTruck = []
    allServicesOrders.forEach((order) => {
      if (ADVANCE_SETTING_SERVICES.includes(order.service_id)) {
        order.open = false
        // order.duration = 1
        if (order.currency) {
          order.currency_symbol = CURRENCY_SYMBOL[order.currency]
        }

        if (order.order_time) {
          order.date = moment.unix(order.order_time).format('YYYY-MM-DD')
          order.time = moment.unix(order.order_time).format('HH:mm')
          order.startOfTime = moment.unix(order.order_time).startOf('hour').format('HH:mm')
        }

        let hasFailedStoppoint = false
        order.path.forEach((point) => {
          if (point.status === ORDER_STATUS.FAILED) {
            hasFailedStoppoint = true
          }
        })

        if (
          order.notify_package_return === true &&
          order.status === ORDER_STATUS.COMPLETED &&
          hasFailedStoppoint
        ) {
          order.returning_status_label = {
            returned: !!(order.path[0].return_time || order.return_time)
          }
        }

        if (
          order.notify_package_return === true &&
          order.status === ORDER_STATUS.COMPLETED &&
          order.path[0].por_type === 'document'
        ) {
          const statusMapping = {
            IN_RETURN: { returned: false },
            RETURNED: { returned: true }
          }

          if (statusMapping[order.sub_status]) {
            order.returning_docs_status_label = statusMapping[order.sub_status]
          }
        }

        ordersTruck.push(order)
      }
    })
    commit(types.SET_ORDERS_TRUCK, ordersTruck)
  }
}

// mutations
const mutations = {
  [types.SET_ORDERS_TRUCK](state, orders) {
    state.orders = orders
  },
  [types.UPDATE_LOADING_ORDERS_TRUCK_STATUS](state, value) {
    state.isLoading = value
  }
  // [types.RESET_DATA_TRUCK] (state) {
  // 	Object.assign(state, INITIAL_DATA_ORDERS_TRUCK)
  // }
}

export default {
  state,
  getters,
  actions,
  mutations
}
